module.exports = __webpack_public_path__ + "files/ea0a12de72e2dc18d04a6ae232138462.eot";


//////////////////
// WEBPACK FOOTER
// ./non_npm_dependencies/google-fonts/fonts/lora-italic-webfont.eot
// module id = 391
// module chunks = 60